import React from 'react';
import { getMessage } from '@tcc/i18n';
import ConfirmationModal from '../../../../../containers/Modal/ConfirmationModal';
import styles from '../../RegionReport.css';

export type DeleteConfirmationViewProps = {
  onDeleteCancelConfirm: () => void;
  onDeleteCancelGoBack: () => void;
  onCancelConfirm: () => void;
};

export const DeleteConfirmationView = ({
  onDeleteCancelConfirm,
  onDeleteCancelGoBack,
  onCancelConfirm,
}: DeleteConfirmationViewProps) => (
  <div
    className={styles.confirmationModalContainer}
    data-test-id='dmb-region-report-delete-confirmation-modal'
  >
    <ConfirmationModal
      confirmButtonText={getMessage('regions.report.modal.delete')}
      handleClickConfirm={onDeleteCancelConfirm}
      handleClickGoBack={onDeleteCancelGoBack}
      handleClickCancel={onCancelConfirm}
      title={getMessage('deleteConfirmationModal.title.report')}
    />
  </div>
);
